import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import Vuelidate from 'vuelidate'
import VeeValidate from 'vee-validate'
import VueMoment from 'vue-moment'

const moment = require('moment')
require('moment/locale/th')

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
VueCookies.config('7d')
Vue.use(Vuelidate)
Vue.use(VeeValidate)
Vue.use(VueMoment, { moment })

Window.Event = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
